import type { UpdateManualSizeBiasBodyDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateManualSizeBiasProducts from "./use-invalidate-manual-size-bias-products";

type UseUpdateManualSizeBiasParams = {
  onSuccess?: () => void;
  onError?: () => void;
};

export default function useUpdateManualSizeBias(
  shopId: string,
  productId: string,
  options?: UseUpdateManualSizeBiasParams,
) {
  const invalidate = useInvalidateManualSizeBiasProducts(shopId);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/sizing/manual-bias/products/{productId}",
    {
      invalidate,
      onSuccess: options?.onSuccess,
      onError: options?.onError,
      mapVariables: (body: UpdateManualSizeBiasBodyDto) => ({
        params: { path: { shopId, productId } },
        body,
      }),
    },
  );
}
